const getSnackbarNotifications = ({ snackbar }) => snackbar.notifications

export const snackbarSelectors = { getSnackbarNotifications }
